import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = this.createApplicationInsights();
    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer(this.telemetryFilter);
  }

  private createApplicationInsights(): ApplicationInsights {
    return new ApplicationInsights({
      config: {
        instrumentationKey: environment.instrumentation_key,
        enableAutoRouteTracking: true,
        disableExceptionTracking: false,
        samplingPercentage: 50,
      },
    });
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }

  private telemetryFilter(envelope: ITelemetryItem) {
    const sampledTypes = ['PageviewData', 'RemoteDependencyData', 'PageviewPerformanceData'];
    const sampleRate = 0.5;

    if (envelope.baseData != null && envelope.baseData['responseCode'] >= 400) {
      return true;
    }
    else if (envelope.baseType !== undefined && sampledTypes.includes(envelope.baseType)) {
      return Math.random() < sampleRate;
    }
    else {
      return true;
    }
  };
}
